import React from 'react';
export function RepeatIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.869 1.993H5.111A3.125 3.125 0 001.99 5.115v13.757a3.124 3.124 0 003.121 3.121h13.758a3.124 3.124 0 003.121-3.12V5.114a3.125 3.125 0 00-3.121-3.122zm1.121 16.88a1.122 1.122 0 01-1.121 1.12H5.111a1.122 1.122 0 01-1.121-1.12V5.114a1.123 1.123 0 011.121-1.122h13.758a1.123 1.123 0 011.121 1.122v13.757z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.992 6.632a.99.99 0 00-.992.932A5.975 5.975 0 006.116 10.8a1 1 0 001.617.97 1 1 0 00.347-.575 3.981 3.981 0 016.676-2.068h-.266a1 1 0 100 2h2.5a1 1 0 001-1v-2.5a1 1 0 00-.998-.995zM17.082 12.012a1 1 0 00-1.179.782 4 4 0 01-6.7 2.068h.284a1 1 0 100-2h-2.5a1.001 1.001 0 00-1.001.999v2.5a1 1 0 001 1 .993.993 0 00.985-.923 5.984 5.984 0 009.889-3.242 1.001 1.001 0 00-.778-1.184z"
  }));
}